import {HistoryMaterialStorage} from '@domain/material-storage'
import {type ScheduleItem} from '@domain/schedule'
import {dataTestId} from '@hconnect/uikit'
import {HPTextField} from '@hconnect/uikit/src/lib2'
import {MenuItem} from '@mui/material'
import type {ChangeEvent} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../../../consts'

interface RemainingStoragesSelectProps {
  selectedAvailableStoragesIds: number[]
  selectedRemainingStoragesIds: number[]
  remainingStorages: HistoryMaterialStorage[]
  scheduleItem: ScheduleItem
  updateScheduleItem: (item: ScheduleItem) => void
}

export const RemainingStoragesSelect: React.FC<RemainingStoragesSelectProps> = ({
  selectedAvailableStoragesIds,
  selectedRemainingStoragesIds,
  remainingStorages,
  scheduleItem,
  updateScheduleItem
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  const onRemainingStorageSelect = (e: ChangeEvent<HTMLInputElement>) => {
    const currentRemainingStoragesIds = e.target.value as unknown as number[]
    updateScheduleItem({
      ...scheduleItem,
      selectedSilos: {
        ...scheduleItem.selectedSilos,
        ids: [...selectedAvailableStoragesIds, ...currentRemainingStoragesIds]
      }
    })
  }

  return (
    <HPTextField
      select
      SelectProps={{multiple: true}}
      label={t('planning.remainingStorages')}
      value={selectedRemainingStoragesIds}
      onChange={onRemainingStorageSelect}
      sx={{width: ({spacing}) => spacing(22)}}
      {...dataTestId('remaining_storages_select')}
    >
      {remainingStorages.map((storage) => (
        <MenuItem
          key={storage.id}
          value={storage.id}
          {...dataTestId(`remaining_storages_option_${storage.name}`)}
        >
          {storage.name}
        </MenuItem>
      ))}
    </HPTextField>
  )
}
